import { Middleware } from "redux";
import { lockableFareApi } from "./api/lockableFareApi";

// Redux action types dispatched when a product is added to or removed from the cart, across all
// product types. Adding/removing a product changes the trip's products (LTD, refund conditions,
// total amount), so the option-eligibility caches must be invalidated. Verified against the
// product reducers (Flight, Accommodation, CarsSearch, Transfers, Poi, Cart, train slice).
const PRODUCT_MUTATION_ACTION_TYPES = new Set<string>([
    // add
    'FLIGHT_ADD_TO_CART',
    'ACCOMMODATION_ADD_TO_CART',
    'CARS_ADD_TO_CART',
    'TRANSFERS_ADD_TO_CART',
    'POI_ADD_TO_CART',
    'CART_ASSISTANCE_ADD_TO_CART',
    'CART_ADD_MANUAL_ITEM',
    'train/addTrainCart',
    // delete / remove
    'FLIGHT_REMOVE_FLIGHT_FROM_CART',
    'FLIGHT_REMOVE_FLIGHT_FROM_CART_BY_ID',
    'ACCOMMODATION_REMOVE_FROM_CART',
    'ACCOMMODATION_REMOVE_FROM_CART_BY_ID',
    'CAR_REMOVE_FROM_CART_BY_ID',
    'TREANSFERS_REMOVE_CART',
    'TRANSFER_REMOVE_FROM_CART_BY_ID',
    'POI_REMOVE_CART',
    'POI_REMOVE_CART_BY_ID',
    'CART_ASSISTANCE_DELETE_BY_ID',
    'CART_MANUAL_PRODUCT_REMOVE_FROM_CART_BY_ID',
    'CART_REMOVE_FROM_MANUAL_ITEM',
    'train/removeTrainCartById'
]);

// On each product add/delete, invalidate the option-eligibility tag so the option_eligibility and
// extend_option_eligibility queries refetch. next(action) runs first so the cart state is already
// updated; the dispatched invalidateTags thunk re-enters the chain and is handled by the api middleware.
export const optionEligibilityInvalidationMiddleware: Middleware = (store) => (next) => (action) => {
    const result = next(action);
    if (action && typeof action.type === 'string' && PRODUCT_MUTATION_ACTION_TYPES.has(action.type)) {
        store.dispatch(lockableFareApi.util.invalidateTags(['option-eligibility']));
    }
    return result;
};
